import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { WindowRef } from './window.service';
import { AppInsightsLoggerService } from './app-insights-logger.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    private windowService: WindowRef,
    private appInsightsLoggerService: AppInsightsLoggerService
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  showModal(modalName: string) {
    const modalElement =
      this.windowService.nativeDocument.getElementById(modalName);

    if (modalElement && modalElement.showModal) {
      modalElement.showModal();
    } else {
      this.appInsightsLoggerService.log('info', 'Info log from Modal.service', `Modal with id ${modalName} not found or doesn't support show method.`);
    }
  }

  closeModal(modalName: string) {
    const modalElement =
      this.windowService.nativeDocument.getElementById(modalName);

    if (modalElement && modalElement.close) {
      modalElement.close();
    } else {
      this.appInsightsLoggerService.log('info', 'Info log from Modal.service', `Modal with id ${modalName} not found or doesn't support close method.`);
    }
  }
}
